import { Base } from "../core/base.model";
import { incidenciaDetalleQABean } from "./incidenciaDetalleQABean.model";
import { IncidenciaDTO } from "./incidenciaDTO";
export class Incidencias extends Base {

    id: number;
	titulo: String;
	estatus: string;
	estatusPrevio: any;
	totalIncidencias: number;
	nomtester: String;
	nomdesarrollador: String;
	prioridad: String;
	fecha_creacion: String;
	fecha_actualizacion: String;
	id_usuario_autor: number;
	id_usuario_desarrollo: number;
	esDesarrolloDesarrollador: boolean;
	id_usuario_qa: number;
	id_proyecto: number;
	id_incidencia_proyecto;
	id_incidencia_cliente: number;
	importada: boolean;
	id_incidencia_qa: number;
	id_cliente: number;
	nombreCliente: string;
	incidenciasXEstatus;
	incidenciasXEstatusCu: String;
	esComentario: number;
	id_ciclo: number;
	color: String;
	imgEstatus: String;
	seleccionada: boolean;
	nombreTarea: String;
	id_tarea: number;
	fechaInicio: String;
	fechaFin: String;
	numI: number;
	id_etapa: number;
	public select: boolean = false;
	media: boolean;
	alta: boolean;
	baja: boolean;
	descincidencia: string;
	porquesResolucion: string[] = [];
	id_version_incidencia: string;
	id_version_resuelto: string;
	id_incidencia: number;
	origen_cliente: string;
	detalleBean : incidenciaDetalleQABean = new incidenciaDetalleQABean();
	version: string;
	numero_comentarios: number;
	numero_archivos: number;
	colorEstatus: String;
	incDTO: IncidenciaDTO = new IncidenciaDTO();

/** FILTROS */
	fec_ini: string;
	fec_fin: string;
	milistaprioridad= [];
	milistaestatus= [];
	numeroInci: number;
	

	idNotificacionUsuario: string;

	tipo: String;
	milistatipo= [];


	

}

